
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M12.528 0C5.612 0 0 5.612 0 12.528s5.612 12.529 12.528 12.529 12.529-5.613 12.529-12.529C25 5.612 19.387 0 12.528 0zm0 24.036V.964c6.35 0 11.565 5.158 11.565 11.564 0 6.35-5.215 11.508-11.565 11.508z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h25v25H0z"}})])])])
          )
        }
      }
    